import React from 'react'

const steps = [
  {
    number: "01",
    title: "Analisi del Tuo Spazio",
    description: "Visito il tuo locale per comprendere le esigenze, lo stile e identificare le migliori opportunità per l'allestimento verde."
  },
  {
    number: "02",
    title: "Progettazione Personalizzata",
    description: "Creo un progetto su misura con essenze selezionate come aceri, ortensie e camelie, pensato per la tua identità."
  },
  {
    number: "03",
    title: "Realizzazione e Manutenzione",
    description: "Realizzo l'allestimento e garantisco la manutenzione continua per mantenere sempre perfetto il tuo spazio verde."
  }
]

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-brand-subtle-bg scroll-mt-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Come Lavoriamo Insieme</h2>
          <p className="text-lg text-brand-text/70 max-w-2xl mx-auto">Un processo semplice e professionale per trasformare il tuo locale in un'oasi verde.</p>
        </div>
        
        <div className="relative">
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-green/10" aria-hidden="true"></div>
          <div className="relative grid md:grid-cols-3 gap-12">
            {steps.map((step) => (
              <div key={step.number} className="bg-white p-8 rounded-lg border border-gray-200/80 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                <span className="text-6xl font-serif font-bold text-brand-green/10 mb-6 block">{step.number}</span>
                <h3 className="text-2xl font-semibold text-brand-green mb-3">{step.title}</h3>
                <p className="text-brand-text/70 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks